import React from 'react';
import AppNavbar from './app-navbar';
import AppHeader from './app-header';
import AppFooter from './app-footer';
import AppFeatures from './app-features';
import AppContact from './app-contact';
import AppTestimonial from './app-testimonial';
import AppPricing from './app-pricing';

export default function AppHome() {
  return (
    <>
      <AppHeader />
      <AppFeatures />
     {/*  <AppPricing />
      <AppTestimonial /> */}
      <AppContact />
    </>
  );
}
